import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useMemo, useState } from 'react';
import { ILegalTransactionRelationship } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { ILegalTransactionRelationshipMember } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMember';
import { ISignatureCertificationLegalClient } from '../../../Interfaces/ISignatureCertificationLegalClient';
import { RelationshipMemberDataView } from './RelationshipMemberDataView';

type RelationshipMemberDataEditDialogProps = {
  relationship: ILegalTransactionRelationship;
  members: ILegalTransactionRelationshipMember[];
  memberLegalClientId?: number;
  onClose: () => void;
  onSave: (
    memberId: number,
    data: ISignatureCertificationLegalClient['signatureCertificationData']
  ) => void;
};

// setSignatureCertificationData={(
//   data: ISignatureCertificationLegalClient['signatureCertificationData']
// ) => {
//   setMembers(
//     members.map(member =>
//       member.idLegalClient === editedMemberRelationshipDataId
//         ? { ...member, data }
//         : member
//     )
//   );
// }}

export const RelationshipMemberDataEditDialog: React.FC<
  RelationshipMemberDataEditDialogProps
> = ({ relationship, members, memberLegalClientId, onClose, onSave }) => {
  const member = useMemo(
    () => members.find(m => m.idLegalClient === memberLegalClientId),
    [memberLegalClientId, members]
  );
  const [data, setData] = useState<any>(member?.data);

  return (
    <Dialog open onClose={onClose} maxWidth='md' fullWidth scroll='paper'>
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant='h5'>
            Datenerfassung {relationship.RelationshipType} (
            {relationship.idRelationship}) - {member?.LegalClient.FirstName}{' '}
            {member?.LegalClient.LastName}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <RelationshipMemberDataView data={data} setData={setData} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
        <Button
          variant='contained'
          onClick={() => {
            if (member && data) {
              onSave(member.idLegalClient, data);
            }
            onClose();
          }}
        >
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};
